import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { SplashCursor } from '../components/SplashCursor';
import { useTheme } from '../theme/ThemeContext';

let THEME = {};
const getStyles = () => StyleSheet.create({
    container: { flex: 1, backgroundColor: THEME.bg, minHeight: '100vh' },
    backgroundContainer: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 },
    scrollContent: { paddingVertical: 60, paddingHorizontal: 20, alignItems: 'center', zIndex: 1 },
    card: {
        backgroundColor: THEME.bgCard, backdropFilter: 'blur(20px)', borderRadius: 32, padding: 48,
        width: '100%', maxWidth: 900, borderWidth: 1, borderColor: THEME.border,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    },
    backButton: {
        marginBottom: 32, alignSelf: 'flex-start', paddingVertical: 8, paddingHorizontal: 16,
        borderRadius: 12, backgroundColor: THEME.bgSurface,
    },
    backButtonText: { color: THEME.textSecondary, fontWeight: '700', fontSize: 12, letterSpacing: 1 },
    title: { fontSize: 48, fontWeight: '800', color: THEME.textPrimary, marginBottom: 12, fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' },
    updatedDate: { fontSize: 14, color: '#3b82f6', fontWeight: '600', marginBottom: 48, letterSpacing: '0.05em', textTransform: 'uppercase' },
    content: { gap: 40 },
    section: { marginBottom: 8 },
    sectionHeader: { fontSize: 22, fontWeight: '700', color: THEME.textPrimary, marginBottom: 16, fontFamily: 'Outfit, sans-serif' },
    subSectionHeader: { fontSize: 18, fontWeight: '600', color: THEME.textPrimary, marginTop: 20, marginBottom: 12 },
    paragraph: { fontSize: 17, lineHeight: 28, color: THEME.textSecondary, marginBottom: 16, fontWeight: '400' },
    contactSection: { marginTop: 40, padding: 32, backgroundColor: 'rgba(59, 130, 246, 0.05)', borderRadius: 24, borderWidth: 1, borderColor: 'rgba(59, 130, 246, 0.1)' },
    contactTitle: { fontSize: 18, fontWeight: '800', color: THEME.textPrimary, marginBottom: 12, letterSpacing: '0.1em' },
    email: { color: '#3b82f6', fontWeight: '600' },
});
let styles = getStyles();

const PrivacyPolicyScreen = () => {
    const navigate = useNavigate();
    const { theme } = useTheme();
    Object.assign(THEME, theme);
    styles = getStyles();

    return (
        <View style={styles.container}>
            {/* Background animation */}
            <View style={styles.backgroundContainer}>
                <SplashCursor
                    BACK_COLOR={theme.splashBackColor}
                    COLOR_UPDATE_SPEED={1}
                    SPLAT_RADIUS={0.2}
                    DENSITY_DISSIPATION={3.5}
                />
            </View>

            <ScrollView contentContainerStyle={styles.scrollContent}>
                <View style={styles.card}>
                    <TouchableOpacity style={styles.backButton} onPress={() => navigate(-1)}>
                        <Text style={styles.backButtonText}>← BACK</Text>
                    </TouchableOpacity>

                    <Text style={styles.title}>Privacy Policy</Text>
                    <Text style={styles.updatedDate}>Updated February 26th 2026</Text>

                    <View style={styles.content}>
                        <View style={styles.section}>
                            <Text style={styles.sectionHeader}>1.1 Data Collection</Text>
                            <Text style={styles.paragraph}>
                                The Application does not collect personally identifiable information, such as name, email, or other identifying details, except for information required for operational purposes and service improvement.
                            </Text>
                            <Text style={styles.paragraph}>
                                The username and password are provided personally and are not linked to identifiable information.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionHeader}>1.2 Use of Information</Text>
                            <Text style={styles.paragraph}>
                                The collected data is used solely for providing services and improving user experience.
                            </Text>
                            <Text style={styles.paragraph}>
                                The Application does not share data with third parties nor use it for commercial purposes.
                            </Text>

                            <Text style={styles.subSectionHeader}>1.2.1 No Sharing</Text>
                            <Text style={styles.paragraph}>
                                Information collected by the Application will not be shared with third parties, except if the user itself chooses to share it (e.g., data export) or when legally required.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionHeader}>1.3 Data Security</Text>
                            <Text style={styles.paragraph}>
                                The Company is committed to maintaining data confidentiality and protecting it through advanced encryption and security protocols.
                            </Text>

                            <Text style={styles.subSectionHeader}>1.3.1 Data Breach Notification</Text>
                            <Text style={styles.paragraph}>
                                In case of a data breach, the Company commits to notifying users and authorities within 72 hours, in compliance with Israeli law and international regulations like GDPR and CCPA.
                            </Text>

                            <Text style={styles.subSectionHeader}>1.3.2 Data Retention Policy</Text>
                            <Text style={styles.paragraph}>
                                Collected data is retained as long as the user remains active in the system or as required for legal and business purposes.
                            </Text>
                            <Text style={styles.paragraph}>
                                Upon termination of use, the data will be securely deleted or archived for legal purposes in accordance with the law.
                            </Text>
                        </View>

                        <View style={styles.section}>
                            <Text style={styles.sectionHeader}>1.4 User Rights</Text>
                            <Text style={styles.paragraph}>
                                In accordance with Israeli privacy laws (and where applicable, GDPR and CCPA), users have the right to access, correct, or delete their collected data.
                            </Text>
                            <Text style={styles.paragraph}>
                                Requests for data deletion can be submitted through the support center.
                            </Text>

                            <Text style={styles.subSectionHeader}>1.4.1 Data Portability</Text>
                            <Text style={styles.paragraph}>
                                Users are entitled to export their data in a readable and standard format (e.g., CSV or JSON).
                            </Text>
                            <Text style={styles.paragraph}>
                                Users can request to transfer their data to another service provider as needed for business or personal purposes.
                            </Text>
                        </View>

                        <View style={styles.contactSection}>
                            <Text style={styles.contactTitle}>CONTACT US</Text>
                            <Text style={styles.paragraph}>
                                We welcome your feedback and questions on this Policy. If you wish to contact us, please email us at <Text style={styles.email}>zohar@reactfirst.ai</Text>.
                            </Text>
                        </View>
                    </View>
                </View>
            </ScrollView>
        </View>
    );
};


export default PrivacyPolicyScreen;
